import React from "react";
import { SegmentStatus } from "../data/mockData";
const STATUS_STYLES: Record<SegmentStatus, {
  label: string;
  className: string;
}> = {
  not_started: {
    label: "Not Started",
    className: "bg-slate-100 text-slate-600"
  },
  in_progress: {
    label: "In Progress",
    className: "bg-amber-50 text-amber-700"
  },
  approved: {
    label: "Approved",
    className: "bg-emerald-50 text-emerald-700"
  },
  requires_review: {
    label: "Requires Review",
    className: "bg-orange-50 text-orange-700"
  },
  new: {
    label: "New",
    className: "bg-sky-50 text-sky-700"
  },
  removed: {
    label: "Removed",
    className: "bg-red-50 text-red-600 line-through"
  }
};
export function SegmentStatusBadge({
  status
}: {
  status: SegmentStatus;
}) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.not_started;
  return <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${style.className}`} data-id="element-221">
      {style.label}
    </span>;
}
export function getSegmentStatusLabel(status: SegmentStatus): string {
  return STATUS_STYLES[status]?.label || status;
}